export default "__VITE_ASSET__dqIUY9ui__"